import { Button, Card, Col, Form, Input, Row, Select, Space, TreeSelect, theme } from 'antd';
import { useEffect, useState } from 'react';
import { computeButtonColLayout, filterFormGridLayout, filterFormItemLayout, filterFormItemStyle } from '@utils/property';
import { filterTreeNodeByTitle } from '@/utils/antdTreeSelect';
import { expertLevels, laborFeeCostBearers } from '@utils/constants';
import './LaborFeeFilterPanel.less';

const VISIBLE_FIELD_COUNT = 6;
const TOTAL_FIELD_COUNT = 11;

export default function LaborFeeFilterPanel({ filter, conferenceHallTreeData, batchNoList = [], onFinish, onReset }) {
    const { token } = theme.useToken();
    const [form] = Form.useForm();
    const [expanded, setExpanded] = useState(false);
    const buttonColLayout = computeButtonColLayout(expanded ? TOTAL_FIELD_COUNT : VISIBLE_FIELD_COUNT);

    useEffect(() => {
        form.setFieldsValue({
            memUsername: filter.memUsername,
            memMobile: filter.memMobile,
            expertLevels: filter.expertLevels,
            conferenceHallId: filter.conferenceHallId,
            agendaConfirmed: filter.agendaConfirmed,
            laborInfoConfirmed: filter.laborInfoConfirmed,
            expertInfoState: filter.expertInfoState,
            batchStatus: filter.batchStatus,
            batchNo: filter.batchNo,
            laborPayStatus: filter.laborPayStatus,
            costBearer: filter.costBearer,
        });
        // 如果有展开字段的值，自动展开
        if (filter.agendaConfirmed !== undefined || filter.laborInfoConfirmed !== undefined || filter.expertInfoState !== undefined || filter.batchStatus !== undefined || filter.batchNo !== undefined || filter.laborPayStatus !== undefined || filter.costBearer !== undefined) {
            setExpanded(true);
        }
    }, [filter, form]);

    const handleReset = () => {
        form.resetFields();
        setExpanded(false);
        onReset();
    };

    return (
        <Card
            size="small"
            className="labor-fee-filter-panel"
            style={{
                marginBottom: token.marginLG,
                border: `1px solid ${token.colorBorderSecondary}`,
                background: token.colorFillAlter,
            }}
        >
            <Form {...filterFormItemLayout} form={form} onFinish={onFinish} autoComplete="off" requiredMark={false}>
                <Row gutter={[16, 16]}>
                    <Col {...filterFormGridLayout}>
                        <Form.Item label="姓名" name="memUsername" style={filterFormItemStyle}>
                            <Input allowClear placeholder="请输入专家姓名" />
                        </Form.Item>
                    </Col>

                    <Col {...filterFormGridLayout}>
                        <Form.Item label="手机号" name="memMobile" style={filterFormItemStyle}>
                            <Input allowClear placeholder="请输入手机号" />
                        </Form.Item>
                    </Col>

                    <Col {...filterFormGridLayout}>
                        <Form.Item label="专家级别" name="expertLevels" style={filterFormItemStyle}>
                            <Select mode="multiple" maxTagCount="responsive" options={expertLevels} fieldNames={{ label: 'label', value: 'level' }} placeholder="请选择专家级别" allowClear />
                        </Form.Item>
                    </Col>

                    <Col {...filterFormGridLayout}>
                        <Form.Item label="任务所属会议" name="conferenceHallId" style={filterFormItemStyle}>
                            <TreeSelect showSearch={{ filterTreeNode: filterTreeNodeByTitle }} styles={{ popup: { root: { minWidth: 500, overflow: 'auto' } } }} allowClear treeDefaultExpandAll treeData={conferenceHallTreeData} placeholder="请选择会议" />
                        </Form.Item>
                    </Col>

                    <Col {...filterFormGridLayout}>
                        <Form.Item label="实际日程" name="agendaConfirmed" style={filterFormItemStyle}>
                            <Select placeholder="请选择" allowClear>
                                <Select.Option value={1}>已确认</Select.Option>
                                <Select.Option value={2}>未反馈</Select.Option>
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col {...filterFormGridLayout}>
                        <Form.Item label="收款信息" name="laborInfoConfirmed" style={filterFormItemStyle}>
                            <Select placeholder="请选择" allowClear>
                                <Select.Option value={1}>已确认</Select.Option>
                                <Select.Option value={2}>未反馈</Select.Option>
                            </Select>
                        </Form.Item>
                    </Col>

                    {expanded && (
                        <>
                            <Col {...filterFormGridLayout}>
                                <Form.Item label="收款信息完整性" name="expertInfoState" style={filterFormItemStyle}>
                                    <Select placeholder="请选择" allowClear>
                                        <Select.Option value={1}>完整</Select.Option>
                                        <Select.Option value={0}>不完整</Select.Option>
                                    </Select>
                                </Form.Item>
                            </Col>

                            <Col {...filterFormGridLayout}>
                                <Form.Item label="付款申请" name="batchStatus" style={filterFormItemStyle}>
                                    <Select placeholder="请选择" allowClear>
                                        <Select.Option value={1}>已申请</Select.Option>
                                        <Select.Option value={0}>未申请</Select.Option>
                                    </Select>
                                </Form.Item>
                            </Col>

                            <Col {...filterFormGridLayout}>
                                <Form.Item label="付款申请时间" name="batchNo" style={filterFormItemStyle}>
                                    <Select placeholder="请选择" allowClear>
                                        {batchNoList.map(item => (
                                            <Select.Option key={item.value} value={item.batchNo}>
                                                {item.createdAt}
                                            </Select.Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>

                            <Col {...filterFormGridLayout}>
                                <Form.Item label="付款状态" name="laborPayStatus" style={filterFormItemStyle}>
                                    <Select placeholder="请选择" allowClear>
                                        <Select.Option value={0}>待付款</Select.Option>
                                        <Select.Option value={1}>已付款</Select.Option>
                                    </Select>
                                </Form.Item>
                            </Col>

                            <Col {...filterFormGridLayout}>
                                <Form.Item label="支付主体" name="costBearer" style={filterFormItemStyle}>
                                    <Select placeholder="请选择" allowClear options={laborFeeCostBearers} fieldNames={{ label: 'label', value: 'value' }} />
                                </Form.Item>
                            </Col>
                        </>
                    )}

                    <Col {...buttonColLayout}>
                        <Form.Item label={<span>&nbsp;</span>} colon={false} style={filterFormItemStyle}>
                            <Space size="small">
                                <Button type="primary" htmlType="submit" icon={<i className="bi bi-search" aria-hidden="true" />}>
                                    检索
                                </Button>
                                <Button type="default" onClick={handleReset}>
                                    重置
                                </Button>
                                <Button type="link" size="small" aria-expanded={expanded} onClick={() => setExpanded(prev => !prev)} style={{ fontSize: 12, color: token.colorTextSecondary }}>
                                    {expanded ? (
                                        <>
                                            收起 <span className="bi bi-chevron-up" aria-hidden="true" />
                                        </>
                                    ) : (
                                        <>
                                            展开 <span className="bi bi-chevron-down" aria-hidden="true" />
                                        </>
                                    )}
                                </Button>
                            </Space>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Card>
    );
}
